export const CONTRACT_STATUSES = [
    {
        id: 'new',
        name: 'New',
    },
    {
        id: 'approved',
        name: 'Approved',
    },
    {
        id: 'draft',
        name: 'Draft',
    },
    {
        id: 'pending',
        name: 'Pending',
    },
    {
        id: 'active',
        name: 'Active',
    },
    {
        id: 'cancelled',
        name: 'Cancelled',
    },
    {
        id: 'expired',
        name: 'Expired',
    },
    {
        id: 'void',
        name: 'Void',
    },
    {
        id: 'pending funding',
        name: 'Pending Funding',
    },
    {
        id: 'paid',
        name: 'Paid',
    },
    {
        id: 'past due',
        name: 'Past Due',
    },
    {
        id: 'pending cancellation approval',
        name: 'Pending Cancellation Approval',
    },
];